import * as _ from "utils";

import React from "react";
import useGroupContext from "hooks/useGroupContext";
import useTranslation from "hooks/useTranslation";

import * as Icons from "components/Icons";
import { Button } from "components/UI";
import RecurringItem from "./RecurringItem";

export default () => {
  const { t } = useTranslation();
  const [group] = useGroupContext();

  return (
    <>
      <div className="space-y-2">
        <h2 id="recurring-lists">{t`group.regularMoments`}</h2>
        {group.regularMoments.length === 0 && (
          <p className="text-caption">{t`group.noRegularMomentsTitle`}</p>
        )}
      </div>
      {group.regularMoments.map((regularMoment) => (
        <RecurringItem
          key={regularMoment.id}
          item={regularMoment}
          onEdit={
            _.isAdmin(group.myMembership)
              ? () =>
                  _.pushModal(
                    `/g/${group.id}/recurring-list/${regularMoment.id}`
                  )
              : null
          }
        />
      ))}
      {_.isAdmin(group.myMembership) && (
        <div className="flex justify-flex-end">
          <Button
            size="sm"
            color="card"
            lead={<Icons.Plus />}
            onClick={() => _.pushModal(`/g/${group.id}/new-recurring-list`)}
          >
            {t`group.addRegularMoment`}
          </Button>
        </div>
      )}
    </>
  );
};
